import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import * as _ from 'lodash';
import { combineLatest, Subject } from 'rxjs';
import { EaChildFormBuilder } from './ea-child-form.builder';

@Component({
    selector: 'ea-child-form',
    templateUrl: './ea-child-form.component.html',
    styleUrls: ['./ea-child-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaChildFormComponent),
        },
    ],
    standalone: false
})
export class EaChildFormComponent extends EaChildFormBuilder implements OnInit {
  users: any[];
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  legalCapacities: any[];
  childFiliations: any[];
  countries = [];
  departments = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private referenceDao: ReferenceDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.referenceDao.getLegalCapacity(),
      this.referenceDao.getChildFiliations(),
      this.referenceDao.getCountries(),
      this.referenceDao.getDepartment(),
    ]).subscribe(
      ([legalCapacities, childFiliations, countries, departments]) => {
        this.legalCapacities = legalCapacities;
        this.childFiliations = childFiliations;
        this.countries = countries;
        this.departments = departments;

        if (!this.entity.id) {
          this.form.controls.nationality.setValue(
            countries.find(country => country.id === 'FR').id,
          );
          this.form.controls.birthCountry.setValue(
            countries.find(country => country.id === 'FR').id,
          );
          this.form.controls.legalCapacity.setValue(legalCapacities[0].id);
          this.form.controls.childFiliation.setValue(childFiliations[0].id);
        }
      },
    );
  }

  get title() {
    return this.entity.id
      ? this.entity.relationUser.label
      : "Ajout d'un enfant";
  }

  onSubmit() {
    //Fetch every form controls value
    let formDTOExtraction = _.merge(this.entity, this.extract());
    this.prFormService.loading();
    this.userDao.updateChild(formDTOExtraction).subscribe(
      success => {
        this.prFormService.loaded();
        this.doneSubject.next();
        this.notificationService.success('La sauvegarde a réussi');
        this.sendAnalyticsEvent('edition-enfant', true);
      },
      errors => {
        console.error(errors);
        this.prFormService.loaded();
        this.notificationService.error('La sauvegarde a échoué');
        this.sendAnalyticsEvent('edition-enfant', false);
      },
    );
  }
}
